import { isCurrentPaymentSystem } from './constants'

export default {
  setStatuses(state, payload) {
    state.statuses = payload
  },
  SET_PROJECT_SYSTEMS(state, payload) {
    state.projectSystems = payload.filter(isCurrentPaymentSystem)
  },
  SET_SYSTEM_TEMPLATES(state, payload) {
    state.systemTemplates = payload.filter(isCurrentPaymentSystem)
  }
}
